"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _immutable = require("immutable");

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _reactImmutableProptypes = require("react-immutable-proptypes");

var _ObjectTypes = require("customer-data-objects/constants/ObjectTypes");

var _ObjectRecordAccessors = require("customer-data-objects/record/ObjectRecordAccessors");

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var _InteractionConfig = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionConfig"));

var _LocalInteractionIdentifier = require("customer-data-communicator/schema/communicator/interaction/local/LocalInteractionIdentifier");

var _PureComponent2 = _interopRequireDefault(require("customer-data-ui-utilities/component/PureComponent"));

var _ComponentMethods = require("customer-data-ui-utilities/component/ComponentMethods");

var _ProfileObjectTypesType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/ProfileObjectTypesType"));

var _SubjectType = _interopRequireDefault(require("customer-data-objects-ui-components/propTypes/SubjectType"));

var _defaultApplicabilityConfig = _interopRequireDefault(require("customer-data-communicator/lib/config/defaultApplicabilityConfig"));

var _FloatingCommunicatorInteraction = _interopRequireDefault(require("./FloatingCommunicatorInteraction"));

var InteractionTypes = _interopRequireWildcard(require("customer-data-communicator/schema/interactions/InteractionTypes"));

var _InteractionTypesType = _interopRequireDefault(require("customer-data-communicator/schema/interactions/InteractionTypesType"));

var INTERACTION_TYPES = Object.keys(InteractionTypes).map(function (type) {
  return InteractionTypes[type];
});
var propTypes = {
  applicabilityConfig: _react.PropTypes.func.isRequired,
  className: _react.PropTypes.string,
  connectRte: _react.PropTypes.func.isRequired,
  defaultInteraction: _InteractionTypesType.default,
  gates: (0, _reactImmutableProptypes.setOf)(_react.PropTypes.string),
  onPasteContent: _react.PropTypes.func,
  handleCloseCommunicator: _react.PropTypes.func,
  handleToggleFullScreen: _react.PropTypes.func,
  handleToggleMinimize: _react.PropTypes.func,
  InteractionConfig: _react.PropTypes.func.isRequired,
  interactionDescriptors: (0, _reactImmutableProptypes.iterableOf)(_InteractionDescriptorRecord.default).isRequired,
  interactionPassThruProps: (0, _reactImmutableProptypes.mapOf)(_react.PropTypes.object, _react.PropTypes.string),
  isFullScreen: _react.PropTypes.bool,
  isFullScreenEnabled: _react.PropTypes.bool,
  isMinimized: _react.PropTypes.bool,
  LocalSettings: _react.PropTypes.object.isRequired,
  objectType: _ProfileObjectTypesType.default.isRequired,
  onInteractionEvent: _react.PropTypes.func.isRequired,
  onInteractionTypeChanged: _react.PropTypes.func.isRequired,
  ownerId: _react.PropTypes.number.isRequired,
  teamId: _react.PropTypes.number,
  paddingClassName: _react.PropTypes.string,
  showHeader: _react.PropTypes.bool,
  subject: _SubjectType.default.isRequired,
  title: _react.PropTypes.node,
  handleUsageLogging: _react.PropTypes.func,
  gdprDisabled: _react.PropTypes.bool,
  handleResizeIframe: _react.PropTypes.func,
  handleNavigationTriggered: _react.PropTypes.func
};
var defaultProps = {
  applicabilityConfig: _defaultApplicabilityConfig.default,
  gates: (0, _immutable.Set)(),
  InteractionConfig: _InteractionConfig.default,
  isFullScreenEnabled: true,
  objectType: _ObjectTypes.CONTACT,
  onPasteContent: _emptyFunction.default,
  onInteractionEvent: _emptyFunction.default,
  onInteractionTypeChanged: _emptyFunction.default,
  ownerId: 0,
  paddingClassName: 'p-x-5',
  handleUsageLogging: _emptyFunction.default,
  gdprDisabled: false,
  handleResizeIframe: _emptyFunction.default,
  handleNavigationTriggered: _emptyFunction.default
};
var FULLSCREEN_INTERACTION_TYPES = [InteractionTypes.NOTE, InteractionTypes.EMAIL, InteractionTypes.LOGGED_CALL, InteractionTypes.LOGGED_EMAIL, InteractionTypes.LOGGED_MEETING];

var Communicator =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(Communicator, _PureComponent);

  function Communicator(props) {
    var _this;

    (0, _classCallCheck2.default)(this, Communicator);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Communicator).call(this, props));
    var interactionDescriptors = props.interactionDescriptors,
        defaultInteraction = props.defaultInteraction,
        applicabilityConfig = props.applicabilityConfig;
    (0, _ComponentMethods.bindHandlers)((0, _assertThisInitialized2.default)(_this));
    _this.interactions = props.InteractionConfig(interactionDescriptors);
    _this.state = {
      selected: _this.interactions.getDefault(_this.getLocalType(), defaultInteraction, applicabilityConfig(props))
    };
    return _this;
  }

  (0, _createClass2.default)(Communicator, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.props.onInteractionTypeChanged(this.state.selected);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.defaultInteraction && this.state.selected !== nextProps.defaultInteraction && INTERACTION_TYPES.includes(nextProps.defaultInteraction)) {
        this.handleInteractionTypeChanged(nextProps.defaultInteraction);
      }
    }
  }, {
    key: "getLocalType",
    value: function getLocalType() {
      var _this$props = this.props,
          defaultInteraction = _this$props.defaultInteraction,
          objectType = _this$props.objectType,
          subject = _this$props.subject,
          LocalSettings = _this$props.LocalSettings;
      return (0, _LocalInteractionIdentifier.getLocalType)(defaultInteraction, objectType, (0, _ObjectRecordAccessors.getId)(subject), LocalSettings.getFrom);
    }
  }, {
    key: "getDescriptorType",
    value: function getDescriptorType() {
      return this.interactions.getDescriptor(this.state.selected).type;
    }
  }, {
    key: "getIsFullScreenEnabled",
    value: function getIsFullScreenEnabled() {
      return this.props.isFullScreenEnabled && FULLSCREEN_INTERACTION_TYPES.includes(this.getDescriptorType());
    }
  }, {
    key: "handleInteractionTypeChanged",
    value: function handleInteractionTypeChanged(type) {
      if (type === this.state.selected) {
        return;
      }

      this.setState({
        selected: type
      });
      this.props.onInteractionTypeChanged(type);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          LocalSettings = _this$props2.LocalSettings,
          applicabilityConfig = _this$props2.applicabilityConfig,
          connectRte = _this$props2.connectRte,
          gates = _this$props2.gates,
          handleCloseCommunicator = _this$props2.handleCloseCommunicator,
          handleToggleFullScreen = _this$props2.handleToggleFullScreen,
          handleToggleMinimize = _this$props2.handleToggleMinimize,
          interactionPassThruProps = _this$props2.interactionPassThruProps,
          isFullScreen = _this$props2.isFullScreen,
          isMinimized = _this$props2.isMinimized,
          objectType = _this$props2.objectType,
          onInteractionEvent = _this$props2.onInteractionEvent,
          ownerId = _this$props2.ownerId,
          teamId = _this$props2.teamId,
          paddingClassName = _this$props2.paddingClassName,
          showHeader = _this$props2.showHeader,
          subject = _this$props2.subject,
          className = _this$props2.className,
          title = _this$props2.title,
          handleUsageLogging = _this$props2.handleUsageLogging,
          gdprDisabled = _this$props2.gdprDisabled,
          onPasteContent = _this$props2.onPasteContent,
          handleResizeIframe = _this$props2.handleResizeIframe,
          handleNavigationTriggered = _this$props2.handleNavigationTriggered;
      var selected = this.state.selected;
      return _react.default.createElement(_FloatingCommunicatorInteraction.default, {
        title: title,
        className: className,
        LocalSettings: LocalSettings,
        applicabilityConfig: applicabilityConfig,
        connectRte: connectRte,
        gates: gates,
        handleCloseCommunicator: handleCloseCommunicator,
        handleToggleFullScreen: handleToggleFullScreen,
        handleToggleMinimize: handleToggleMinimize,
        interactionPassThruProps: interactionPassThruProps,
        interactions: this.interactions,
        isFullScreenEnabled: this.getIsFullScreenEnabled(),
        isFullScreen: isFullScreen,
        isMinimized: isMinimized,
        objectType: objectType,
        onPasteContent: onPasteContent,
        onInteractionEvent: onInteractionEvent,
        onInteractionTypeChanged: this.handleInteractionTypeChanged,
        ownerId: ownerId,
        teamId: teamId,
        paddingClassName: paddingClassName,
        selected: selected,
        showHeader: showHeader,
        subject: subject,
        handleUsageLogging: handleUsageLogging,
        gdprDisabled: gdprDisabled,
        handleResizeIframe: handleResizeIframe,
        handleNavigationTriggered: handleNavigationTriggered
      });
    }
  }]);
  return Communicator;
}(_PureComponent2.default);

Communicator.propTypes = propTypes;
Communicator.defaultProps = defaultProps;
var _default = Communicator;
exports.default = _default;
module.exports = exports.default;